import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function getHotelContractFileURL(hotelContractId) {
  const {
    host,
    URIs: { getHotelContractFileURL },
  } = apiConfig;

  const uri = `${host}${getHotelContractFileURL}`.replace(':hotelContractId', hotelContractId);

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));

  return axios
    .post(uri, {
      data: {
        hotelReference: 'civitfun',
        accessToken: storedCredentials.accessToken,
      }
    })
    .then(res => {
      return res.data;
    });
}
